import React, { useState, useEffect } from "react";

import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

import AirbyteApi from "apis/airbyte";
import { PageLoader, Typography } from "clearsense-ui/components";

import { CONFIG_TYPES } from "../constants";
import { formatBytes } from "../utils";

dayjs.extend(duration);

const Jobs = ({ connectionId }) => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchJobs = async () => {
    const payload = {
      configId: connectionId,
      configTypes: ["sync", "reset_connection"],
    };
    try {
      setLoading(true);
      const { data } = await AirbyteApi.fetchJobs(payload);
      setJobs(data.jobs);
    } catch (error) {
      logger.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  const formatDuration = (startingTime, endingTime) => {
    if (!startingTime || !endingTime) return "0s";
    const duration = dayjs
      .unix(endingTime)
      .from(dayjs.unix(startingTime), true);
    return duration;
  };

  if (loading) {
    return (
      <div>
        <PageLoader />
      </div>
    );
  }

  return (
    <div>
      {jobs.length > 0 && (
        <>
          <Typography style="h4" className="border-b-2">
            Sync History
          </Typography>
          <div className="space-y-4 ">
            {jobs?.map(({ attempts, job }) => {
              const attempt = attempts[0];
              return (
                <div key={attempt?.id} className="my-2">
                  <Typography style="medium" className="capitalize">
                    {job?.status}
                  </Typography>
                  <div className="flex space-x-2 ">
                    <Typography style="small" className="text-gray-500">
                      {formatBytes(attempt?.bytesSynced)} |{" "}
                      {attempt?.totalStats?.recordsEmitted ?? "No"} emitted
                      records | {attempt?.totalStats?.recordsCommitted ?? "No"}{" "}
                      commited records |{" "}
                      {formatDuration(
                        attempt?.createdAt,
                        attempt?.endedAt ?? attempt?.updatedAt
                      )}{" "}
                      | {CONFIG_TYPES[job.configType]}
                    </Typography>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};
export default Jobs;
